module.exports = __webpack_public_path__ + "static/media/8.c6a641dd.jpg";